module.exports = __webpack_public_path__ + "a40a308a024dda3f3da84ee1b9243b2a.png";